/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
/**
 *
 * @description Toggles an item in an array without mutating it.
 * @param array Array to add/remove the item from
 * @param newItem Item to toggle in the array
 */
export function toggleArrayItem<T = string | number>(array: T[], newItem: T) {
  return array.includes(newItem)
    ? array.filter((x) => x !== newItem)
    : [...array, newItem];
}
